import Collapse from './Collapse';
export default Collapse;
var Panel = Collapse.Panel;
export { Panel };


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-collapse/es/index.js
// module id = 440
// module chunks = 0